document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelectorAll(".ap-pdp").length > 0) {
    const tabs = document.querySelectorAll(".tab-title");
    const tabContents = document.querySelectorAll(".gen-tab-content");
    const pdpGen = document.getElementById("ap-pdp");

    tabs.forEach((tab) => {
      tab.addEventListener("click", (event) => {
        console.log("tab clicked");
        console.log(pdpGen);
        const tabId = event.target.getAttribute("href").replace("#", "");
        if (tabId === "tab-description") {
          tabContents.forEach((tabContent) => {
            tabContent.classList.add("is-hide");
          });
          if (pdpGen) pdpGen.classList.remove("is-hide");
        } else {
          tabContents.forEach((tabContent) => {
            tabContent.classList.remove("is-hide");
          });
          if (pdpGen) pdpGen.classList.add("is-hide");
        }
      });
    });
  } else {
    return;
  }
});
